import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/next@12.2.0_@babel+core@7.16.0_react-dom@17.0.2_react@17.0.2/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject;

import styled from 'styled-components';
export var StyledFormContainer = styled.div.withConfig({
  displayName: "StyledFormContainer",
  componentId: "sc-qm9lc6-0"
})(["align-items:flex-start;background:#ffffff;border-radius:16px;display:flex;flex-direction:column;width:45vw;max-width:435px;padding:20px;position:relative;border:0.5px solid #e7e2ff;", ""], _ref => {
  var theme = _ref.theme;
  return theme.media.lg(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 100% !important;\n  "])));
});
export var StyledFormTitle = styled.div.withConfig({
  displayName: "StyledFormTitle",
  componentId: "sc-qm9lc6-1"
})(["font-size:24px;font-weight:600;line-height:150%;color:#000000;"]);
export var StyledFormContent = styled.div.withConfig({
  displayName: "StyledFormContent",
  componentId: "sc-qm9lc6-2"
})(["display:flex;flex-flow:column nowrap;gap:28px;width:100%;margin-top:24px;"]);
export var StyledInputTokensWrapper = styled.div.withConfig({
  displayName: "StyledInputTokensWrapper",
  componentId: "sc-qm9lc6-3"
})(["display:flex;flex-flow:row nowrap;justify-content:space-between;align-items:center;gap:16px;width:100%;margin-top:8px;", ""], _ref2 => {
  var wrap = _ref2.wrap;
  return wrap && "\n      flex-wrap: wrap;\n      justify-content: flex-start;\n    ";
});